import { FC } from 'react'
import { Col } from 'antd'
import PerFlexRow from '../../components/custom_components/FlexRow'
import PerText from '../../components/custom_components/Text'

interface ProfileLabelListComponentProps {
  label: string
  value: unknown
}

export const ProfileLabelListComponent: FC<ProfileLabelListComponentProps> = ({ label, value }) => {
  return (
    <PerFlexRow mb="xs" align="middle">
      <Col span={8}>
        <PerText appearance="info" color="secondary">
          {label}
        </PerText>
      </Col>
      <Col span={16}>
        <PerText>{value}</PerText>
      </Col>
    </PerFlexRow>
  )
}
